import { gsap } from 'gsap';
import morphSVG from './../MorphSVGPlugin';

(function($){

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */

  var initializeBlock = function( $block ) {
    gsap.registerPlugin(morphSVG)

    // Matches MD tailwindCSS responsive breakpoint
    function addHovers(md) {
      if (md.matches) {
        $(".left-hover, .left-pointer").mouseover( function() { 
          gsap.to('.left-svg', { morphSVG: 'M1072.8,0H0V600H934.2C868.9,289.6,1181.7,280.6,1072.8,0Z', ease: 'power1.inOut', opacity: 1.0})
          gsap.to('.right-svg', { morphSVG: 'M1440,600H934.2C868.9,289.5,1181.7,280.6,1072.8,0H1440Z', ease: 'power1.inOut', opacity: 0.4})
    
          // Left Side adjustments
          sideAdjustment('left')
    
          // Right Side adjustments
          $('.right-content').addClass('tw-opacity-0').removeClass('tw-opacity-100')
        });
      
        $(".right-hover, .right-pointer").mouseover( function() { 
          console.log('right hover')
          gsap.to('.left-svg', { morphSVG: 'M548,0H0V600H364.9C548,385.5,206.4,200.2,548,0Z', ease: 'power1.inOut', opacity: 0.4})
          gsap.to('.right-svg', { morphSVG: 'M548,0c-341.6,200.2,0,385.5-183.1,600H1440V0Z', ease: 'power1.inOut', opacity: 1.0})
    
          // Right Side adjustments
          sideAdjustment('right')
          
          // Left Side reset
          $('.left-content').addClass('tw-opacity-0').removeClass('tw-opacity-100')
        });
    
    
        $(".right-hover, .right-content, .left-hover, .left-content").mouseleave( () => { resetToCenter() });
      } else {
        // Reset for Mobile to make sure everything is proper if needed
      }
    }


    function sideAdjustment(side) {
      $(`.${side}-content`).addClass('tw-opacity-100').removeClass('tw-opacity-0')

      if (side == 'left') {
        $(`.${side}-content-inner`).addClass('tw-bg-white md:tw--translate-x-1/3 md:tw--translate-y-1/2').removeClass('md:tw--translate-x-1/4 md:tw--translate-y-1/4')
      } else {
        $(`.${side}-content-inner`).addClass('tw-bg-white md:tw-translate-x-1/4 md:tw--translate-y-1/2').removeClass('md:tw-translate-x-3/4 md:tw--translate-y-1/4')
      }

      $(`.${side}-title`).removeClass('tw-text-white').addClass('tw-text-teal-600')
      $(`.${side}-content-more-info`).addClass('md:tw-opacity-100').removeClass('md:tw-opacity-0')
    }


    function resetToCenter() {
      gsap.to('.left-svg', { morphSVG: 'M823.1,0H0V600H587C521.7,289.5,876.7,354.8,823.1,0Z', ease: 'power1.inOut', opacity: 1.0})
      gsap.to('.right-svg', { morphSVG: 'M1440,600H587C521.7,289.5,876.7,354.8,823.1,0H1440Z', ease: 'power1.inOut', opacity: 1.0})
      
      // Unified Reset
      $('.right-content, .left-content').addClass('tw-opacity-100').removeClass('tw-opacity-0')
      $('.left-content-inner').removeClass('tw-bg-white md:tw--translate-x-1/3 md:tw--translate-y-1/2').addClass('md:tw--translate-x-1/4 md:tw--translate-y-1/4')
      $('.right-content-inner').removeClass('tw-bg-white md:tw-translate-x-1/4 md:tw--translate-y-1/2').addClass('md:tw-translate-x-3/4 md:tw--translate-y-1/4')
      $('.right-title, .left-title').addClass('tw-text-white').removeClass('tw-text-teal-600')
      $('.right-content-more-info, .left-content-more-info').addClass('md:tw-opacity-0').removeClass('md:tw-opacity-100')
    }

    let md = window.matchMedia("(min-width: 768px)")
    addHovers(md)
    md.addListener(addHovers)
  }

  // Initialize each block on page load (front end).
  $(document).ready(function(){
    $('.image-split-slider-block').each(function(){
      initializeBlock( $(this) );
    });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
      window.acf.addAction( 'render_block_preview/type=image-split-slider-section', initializeBlock );
  }

})(jQuery);
